import { useCallback } from 'react'
import { UseFormReturn } from 'react-hook-form'

import { CustomerForm } from '../../../types/customerForm'

export const contactFieldsToReset = ['contactEmail', 'contactFirstName', 'contactLastName', 'isContactPrimary'] as const

export const mainPrimaryContactFields = ['firstName', 'lastName', 'email'] as const

export const useContactPersonFormActions = (customerForm: UseFormReturn<CustomerForm>) => {
  const { resetField, setValue } = customerForm

  const resetContactFormFields = useCallback(() => {
    for (const field of contactFieldsToReset) {
      resetField(field)
    }
  }, [resetField])

  const setMainPrimaryContactFields = useCallback(
    (data: { email?: string; firstName?: string; lastName?: string }) => {
      for (const field of mainPrimaryContactFields) {
        setValue(field, data[field] ?? '')
      }
    },
    [setValue],
  )

  const clearMainPrimaryContactFields = useCallback(() => {
    for (const field of mainPrimaryContactFields) {
      setValue(field, '')
    }
  }, [setValue])

  return {
    clearMainPrimaryContactFields,
    resetContactFormFields,
    setMainPrimaryContactFields,
  }
}
